module.exports = __webpack_public_path__ + "img/friends_wishlist.91934da1.png";